export default __webpack_public_path__ + "static/media/logisticOrangeLeft.c4b84ffa.svg";